import {
  CountryCode,
  StoreCountryName,
  MultiTenancyHeader,
  getMultiTenancyHeaders as apiGetMultiTenancyHeaders,
} from '@jbhi-fi/apis/src/utils/multiTenancyHeaders';

const locationHeaderValues: Record<CountryCode, StoreCountryName> = {
  AU: 'Australia',
  NZ: 'New Zealand',
};

export const getStoreCountryName = (): StoreCountryName => {
  return locationHeaderValues[window.Jbhifi.storeLocation];
};

export const getMultiTenancyHeaders = (): Record<MultiTenancyHeader, string> => {
  return apiGetMultiTenancyHeaders(window.Jbhifi.storeLocation);
};
